import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const fetchSlotAvailability = async (eventPk, tierPk, month) => {
  const response = await axios.get(
    routes.ticketTierSlotsAvailability(eventPk, tierPk) + `?month=${month}`,
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};

export default fetchSlotAvailability;
